import MainLayout from "@/components/layout/admin/MainLayout.vue";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import CONFIG from "@/assets/js/config.js";
import axios from "axios";

export default {
  name: "LeaveDetail",
  components: {
    MainLayout,
    Loading,
  },

  data() {
    return {
      CONFIG,
      noDataMsg: CONFIG.NO_DATA_EXIST,
      isLoading: false,
      leaveData: {},
    };
  },

  methods: {
    getLeaveDetail() {
      axios.get('teacher/leave/detail/' + this.$route.params.id)
        .then((response) => {
          this.leaveData = response.data;
          this.isLoading = false;
        })
        .catch((error) => {
          if (error.response && error.response.status == 401) {
            this.$store.commit('logout');
            window.location.replace('login');
          }
          this.isLoading = false;
        });
    },
  },

  mounted() {
    this.isLoading = true;
    this.getLeaveDetail();
  },
};
